module.exports = __webpack_public_path__ + "static/images/going_box_title.5be41f4.png";